import {Component} from '@angular/core';
import {LoanApplicationService} from '../../loan-application.service';
import {CountrySelectService} from '../../../../@modules/country-select/country-select.service';
import {LoanApplication} from '../../../../@models/loan-application.model';
import { OfwStatusSelectService } from 'src/app/@modules/ofw-status-select/ofw-status-select.service';

@Component({
  selector: 'bb-land-based',
  templateUrl: './land-based.component.html',
  styleUrls: ['./land-based.component.scss'],
})
export class LandBasedComponent {
  employment_channel = LoanApplication.EmploymentChannel;
  employment_info = this.loan.form.get('employment_info');

  constructor(public loan: LoanApplicationService,
              public country: CountrySelectService,
              public ofwStatus: OfwStatusSelectService) {
  }
}
